import React, { useEffect } from "react";
import Screen1 from "./Screen1";
import Screen2 from "./Screen2";
import Screen3 from "./Screen3";
import Screen4 from "./Screen4";
import Screen5 from "./Screen5";

export default function Body({
  currentScreen,
  goToNextScreen,
  resetToFirstScreen,
  marketProductCode,
  selectedStateData,
  siteId,
  brandId,
  countryIso2Code,
  onPremise,
  ePremise,
}) {
  return (
    <>
      <div id="bf-chat-window-body">
        {currentScreen === 1 && (
          <Screen1
            onNext={goToNextScreen}
            onReset={resetToFirstScreen}
            onPremise={onPremise}
            ePremise={ePremise}
          />
        )}
        {currentScreen === 2 && (
          <Screen2
            onNext={goToNextScreen}
            onReset={resetToFirstScreen}
            country_iso2_code={countryIso2Code}
            brand_id={brandId}
          />
        )}
        {currentScreen === 3 && (
          <Screen3
            onNext={goToNextScreen}
            onReset={resetToFirstScreen}
            productCode={marketProductCode}
          />
        )}
        {currentScreen === 4 && (
          <Screen4
            onNext={goToNextScreen}
            onReset={resetToFirstScreen}
            stateData={selectedStateData}
          />
        )}
        {currentScreen === 5 && (
          <Screen5
            onNext={goToNextScreen}
            onReset={resetToFirstScreen}
            country_iso2_code={countryIso2Code}
            siteId={siteId}
            brandId={brandId}
          />
        )}
      </div>
    </>
  );
}
